var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.5 4.5H10.5C9.71207 4.5 8.93185 4.65519 8.2039 4.95672C7.47594 5.25825 6.81451 5.7002 6.25735 6.25735C5.7002 6.81451 5.25825 7.47594 4.95672 8.2039C4.65519 8.93185 4.5 9.71207 4.5 10.5V21.5C4.5 22.2879 4.65519 23.0681 4.95672 23.7961C5.25825 24.5241 5.7002 25.1855 6.25735 25.7426C6.81451 26.2998 7.47594 26.7418 8.2039 27.0433C8.93185 27.3448 9.71207 27.5 10.5 27.5H21.5C22.2879 27.5 23.0681 27.3448 23.7961 27.0433C24.5241 26.7418 25.1855 26.2998 25.7426 25.7426C26.2998 25.1855 26.7418 24.5241 27.0433 23.7961C27.3448 23.0681 27.5 22.2879 27.5 21.5V10.5C27.5 9.71207 27.3448 8.93185 27.0433 8.2039C26.7418 7.47594 26.2998 6.81451 25.7426 6.25735C25.1855 5.7002 24.5241 5.25825 23.7961 4.95672C23.0681 4.65519 22.2879 4.5 21.5 4.5ZM16 21C15.0111 21 14.0444 20.7068 13.2221 20.1573C12.3999 19.6079 11.759 18.827 11.3806 17.9134C11.0022 16.9998 10.9031 15.9945 11.0961 15.0245C11.289 14.0546 11.7652 13.1637 12.4645 12.4645C13.1637 11.7652 14.0546 11.289 15.0245 11.0961C15.9945 10.9031 16.9998 11.0022 17.9134 11.3806C18.827 11.759 19.6079 12.3999 20.1573 13.2221C20.7068 14.0444 21 15.0111 21 16C21 17.3261 20.4732 18.5978 19.5355 19.5355C18.5978 20.4732 17.3261 21 16 21Z",
    fill: "#2D3740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21Z",
    stroke: "#2D3740",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4.5H10.5C7.18629 4.5 4.5 7.18629 4.5 10.5V21.5C4.5 24.8137 7.18629 27.5 10.5 27.5H21.5C24.8137 27.5 27.5 24.8137 27.5 21.5V10.5C27.5 7.18629 24.8137 4.5 21.5 4.5Z",
    stroke: "#2D3740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11C23.3284 11 24 10.3284 24 9.5C24 8.67157 23.3284 8 22.5 8C21.6716 8 21 8.67157 21 9.5C21 10.3284 21.6716 11 22.5 11Z",
    fill: "#2D3740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogoNew);
export default __webpack_public_path__ + "static/media/InstagramLogoNew.afa11c24bce4bea87007c9ca63a456d5.svg";
export { ForwardRef as ReactComponent };